import { useState } from "react";
import { Link } from "react-router-dom";
import "./TestAccreditationFaculties.css";
import { facultiesdata } from "../../../data/facultiesdata";

const FALLBACK_IMG = "/image-fix/fallbacks/faculty-fallback.jpg";

/* Same data & links as old home (home-faculties.js): from facultiesdata, link = /faculties/:slug */
const faculties = Object.entries(facultiesdata).map(([slug, f]) => ({
  slug,
  name: f.name,
  icon: f.icon,
  image: f.image || f.welcometxtbgimage || f.bottombgimage || FALLBACK_IMG,
  link: `/faculties/${slug}`,
  accent: "#0C1F3F",
  light: "#F5ECD4",
}));

const accredSteps = [
  { step: "01", label: "Self-Assessment", done: true },
  { step: "02", label: "Documentation", done: true },
  { step: "03", label: "External Review", done: false, current: true },
  { step: "04", label: "Formal Recognition", done: false },
];

export default function TestAccreditationFaculties() {
  const [imgErrors, setImgErrors] = useState({});
  const handleImgError = (index) => setImgErrors((prev) => ({ ...prev, [index]: true }));

  return (
    <section className="th-accred-block th-mi-section" aria-label="Accreditation and Faculties">
      <div className="th-mi-container">
        <div className="th-mi-banner">
          <div className="th-mi-banner__left">
            <span className="th-mi-banner__eyebrow">Accreditation</span>
            <h2 className="th-mi-banner__title">Advancing Towards<br />EU Recognition</h2>
            <p className="th-mi-banner__desc">
              The European School of Business &amp; Diplomacy is undergoing the
              formal MFHEA accreditation process as an EU-recognised Higher
              Education Institution, delivering innovative online and distance
              learning across Malta and beyond.
            </p>
          </div>
          <div className="th-mi-banner__right">
            <div className="th-mi-fw-pill">
              <div className="th-mi-fw-pill__logo">
                <img src="/image-fix/accreditation-logos/malta-qualification-framework-removebg-preview.png" alt="Malta Qualification Framework" className="th-mi-fw-pill__img" onError={(e) => { e.target.style.display = "none"; }} />
              </div>
            </div>
            <div className="th-mi-fw-pill">
              <div className="th-mi-fw-pill__logo">
                <img src="/image-fix/accreditation-logos/European_Qualifications_Framework-removebg-preview.png" alt="European Qualifications Framework" className="th-mi-fw-pill__img" onError={(e) => { e.target.style.display = "none"; }} />
              </div>
            </div>
          </div>
        </div>

        <div className="th-mi-progress">
          {accredSteps.map((s, i) => (
            <div key={i} className={`th-mi-progress__step${s.done ? " th-mi-progress__step--done" : ""}${s.current ? " th-mi-progress__step--current" : ""}`}>
              <div className="th-mi-progress__dot">
                {s.done ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg> : s.step}
              </div>
              <span className="th-mi-progress__label">
                {s.label}
                {s.current && <span className="th-mi-progress__tag">In Progress</span>}
              </span>
            </div>
          ))}
        </div>

        <div className="th-mi-faculties__header">
          <h3 className="th-mi-faculties__title">Our Faculties</h3>
          <span className="th-mi-faculties__count">{faculties.length} Disciplines</span>
        </div>
        <div className="th-mi-faculties__grid">
          {faculties.map((f, i) => (
            <Link key={f.slug} to={f.link} className="th-mi-card" style={{ "--card-accent": f.accent, "--card-light": f.light }}>
              <div className="th-mi-card__image-wrap" style={imgErrors[i] ? { background: "linear-gradient(135deg,#0C1F3F,#142d54)" } : undefined}>
                {!imgErrors[i] && <img className="th-mi-card__image" src={f.image} alt={f.name} loading="lazy" onError={() => handleImgError(i)} />}
                <div className="th-mi-card__overlay" />
                <div className="th-mi-card__badge"><i className={f.icon} aria-hidden="true" /></div>
              </div>
              <div className="th-mi-card__body">
                <div className="th-mi-card__name">{f.name}</div>
                <div className="th-mi-card__footer">
                  <span className="th-mi-card__explore">Explore</span>
                  <span className="th-mi-card__arrow">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M4 10L10 4M10 4H5M10 4v5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="th-mi-cta">
          <a href="/register-your-interest" className="th-mi-cta__btn">
            Start Your Application
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M5 13L13 5M13 5H6M13 5v7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </a>
          <p className="th-mi-cta__sub">Programmes starting March 2027 — Applications open</p>
        </div>
      </div>
    </section>
  );
}
